import { ACTIVATION_CUSTOM_TASK_ICONS } from '../../../../constants/activation-task';

export default function useCustomTaskIcons() {
    const getType = (task) => {
        const customIcon = ACTIVATION_CUSTOM_TASK_ICONS.find((icon) => task.type_icon === icon.name);

        if (!customIcon) {
            console.error(`Unsupported Activation task type_icon for "${task.type_icon}"`);
            return 'solid';
        }
        return customIcon.type;
    };

    const getName = (task) => {
        if (!task.type_icon) {
            return null;
        }

        const customIcon = ACTIVATION_CUSTOM_TASK_ICONS.find((icon) => task.type_icon === icon.name);

        if (!customIcon) {
            console.error(`Unsupported Activation task type_icon for "${task.type_icon}"`);
            return 'star-of-life';
        }
        return customIcon.icon;
    };

    return {
        getType,
        getName
    };
}
